import classNames from "classnames";
import { sanitizeHtml } from "lib/util";

export const DescriptionSection = ({
  item,
  section: { value },
  full,
}: {
  item: Travelguide.OOI;
  section: Travelguide.POISection.Description;
  full?: boolean;
}) => {
  return (
    <section
      className={classNames("flex flex-col gap-5 px-4", {
        "md:px-6": !full,
        "md:px-0": full,
      })}
    >
      <p className="font-bold">{item.shortText}</p>
      {sanitizeHtml(value)}
    </section>
  );
};
